import QuickTime from 'src/components/QuickTime/QuickTime';
import { connect } from 'react-redux';
import { QuickTimesActionCreator, RMTimesActionCreator, FrameworkActionCreator, AppointmentActionCreator } from 'src/store/states';
import { ClearQuickTimes } from 'src/store/states/QuickTimes/QuickTimesSlice';
import { IStoreState } from 'src/store';
import { BlankDeptSpec } from 'src/models/Specs/TestSpecs';

const mapStateToProps = (state: IStoreState) => ({
    specData: state.Specs.specs,
    customerInfo: state.Customer.Customer,
    quickTimes: state.QuickTimes.quickTimes,
    qtimeSlots: state.QuickTimes.qtimeSlots,
    quickTimesSlice: state.QuickTimes,
    lastDeptRan: state.QuickTimes.lastDeptRan,
    recallFlagUsed: state.QuickTimes.recallFlagUsed !== undefined ? state.QuickTimes.recallFlagUsed : false,
    // menus: state.Menus.allMenus.menus,
    specProfile: state.Framework.specProfile,
    vehicles: state.Vehicles.vehicles,
    selectedVehicle: state.Vehicles.selectedVehicle,
    specDeptData: state.Specs.deptSpecs !== undefined ? state.Specs.deptSpecs : BlankDeptSpec,
    appointment: state.Appointment.Appointment,
    invalidDates: state.RMTimes.invalidDates,
    theme: state.Framework.theme,
    colorSensitiveEnabled: state.Framework.colorSensitiveEnabled,
    invalidDatesDept: state.RMTimes.invalidDatesDept,
    apptDept: state.Appointment.Appointment.department,
    apptCust: state.Appointment.ApptCust,
    apptOps: state.Appointment.ApptOps,
    checkedRecalls: state.AdditionalServices.checkedRecalls,
    locale: state.Framework.locale,
    gmossVersion: state.Framework.gmossVersion ?? '',
    mainPaneViewOrder: state.Framework.mainPaneViewOrder,
    sessionId: state.Framework.sessionId,
    lexusMCLaunched: state.Framework.lexusMCLaunched,
    toyotaMCLaunched: state.Framework.toyotaMCLaunched,
    lexusTDMCLaunched: state.Framework.lexusTDMCLaunched,
    toyotaTDMCLaunched: state.Framework.toyotaTDMCLaunched,
    appointmentData: state.Appointment,
    identityVerified: state.Customer.identityVerified,
});

const mapDispatchToProps = {
    getQuickTimes: QuickTimesActionCreator.GetQuickTimes,
    getRMTimes: RMTimesActionCreator.GetRMTimes,
    pushToMainPanes: FrameworkActionCreator.pushToMainPane,
    updateApptDate: AppointmentActionCreator.UpdateApptDate,
    getInvalidDates: RMTimesActionCreator.GetInvalidDates,
    clearInvalidDates: RMTimesActionCreator.ClearInvalidDates,
    addLogEntry: FrameworkActionCreator.addLogEntry,
    popFromMainPane: FrameworkActionCreator.popFromMainPane,
    clearQuickTimes: ClearQuickTimes,
};

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(QuickTime);